import Vue from 'vue';
import VueRouter from 'vue-router';
import VueRouterMultiguard from 'vue-router-multiguard';

import Login from '@/pages/Login.vue';
import Orders from '@/pages/Orders.vue';
import OrdersOrders from '@/pages/Orders/Orders.vue';
import OrderDetails from '@/pages/OrderDetails.vue';
import Contractors from '@/pages/Contractors.vue';
import ContractorDetails from '@/pages/ContractorDetails.vue';
import ContractorDetailsInfo from '@/pages/ContractorDetails/ContractorInfo.vue';
import ContractorDetailsOrders from '@/pages/ContractorDetails/ContractorOrders.vue';
import ContractorDetailsTransactions from '@/pages/ContractorDetails/ContractorTransactions.vue';
import ContractorDetailsCommunications from '@/pages/ContractorDetails/ContractorCommunications.vue';
import ContractorEdit from '@/pages/ContractorDetails/ContractorEdit.vue';
import Customers from '@/pages/Customers.vue';
import SupportCommunications from '@/pages/SupportCommunications.vue';
import CustomerDetails from '@/pages/CustomerDetails.vue';
import CustomerDetailsInfo from '@/pages/CustomerDetails/CustomerInfo.vue';
import CustomerDetailsOrders from '@/pages/CustomerDetails/CustomerOrders.vue';
import CustomerDetailsObjects from '@/pages/CustomerDetails/CustomerObjects.vue';
import CustomerDetailsCommunications from '@/pages/CustomerDetails/CustomerCommunications.vue';
import Objects from '@/pages/Objects.vue';
import ObjectDetails from '@/pages/ObjectDetails.vue';
import ObjectDetailsInfo from '@/pages/ObjectDetails/ObjectDetailsInfo.vue';
import ObjectDetailsActions from '@/pages/ObjectDetails/ObjectDetailsActions.vue';
import ObjectDetailsOrders from '@/pages/ObjectDetails/ObjectDetailsOrders.vue';
import ObjectsObjects from '@/pages/Objects/Objects.vue';
import ObjectNew from '@/pages/Objects/ObjectNew.vue';
import ObjectEdit from '@/pages/Objects/ObjectEdit.vue';
import ObjectNewSingle from '@/pages/Objects/ObjectNew/ObjectNewSingle.vue';
import ObjectNewFamily from '@/pages/Objects/ObjectNew/ObjectNewFamily.vue';
import Settings from '@/pages/Settings.vue';
import SettingsLimit from '@/pages/Settings/SettingsLimit.vue';
import SettingsOrders from '@/pages/Settings/SettingsOrders.vue';
import SettingsLegal from '@/pages/Settings/SettingsLegal.vue';
import SettingsAdmins from '@/pages/Settings/SettingsAdmins.vue';
import SettingsAdminEdit from '@/pages/Settings/SettingsAdminEdit.vue';
import SettingsRegions from '@/pages/Settings/SettingsRegions.vue';
import SettingsMonitoring from '@/pages/Settings/SettingsMonitoring.vue';
import SettingsAnalytics from '@/pages/Settings/SettingsAnalytics.vue';
import SettingsSms from '@/pages/Settings/SettingsSms.vue';
import SettingsEmail from '@/pages/Settings/SettingsEmail.vue';
import SettingsMessageTemplates from '@/pages/Settings/SettingsMessageTemplates.vue';
import SettingsDB from '@/pages/Settings/SettingsDB.vue';
import Requests from '@/pages/Requests.vue';
import RequestsRegistration from '@/pages/Requests/RequestsRegistration.vue';
import RequestsChange from '@/pages/Requests/RequestsChange.vue';

import Services from '@/pages/Services.vue';
import ServicesCategories from '@/pages/Services/ServicesCategories.vue';
import CategoryNew from '@/pages/Services/Category/CategoryNew.vue';
import ServicesCategoriesNewHeader from '@/components/global/header/ServicesCategoriesNewHeader.vue';
import Category from '@/pages/Services/Category/Category.vue';
import CategoryAbout from '@/pages/Services/Category/CategoryAbout.vue';
import CategoryServices from '@/pages/Services/Category/CategoryServices.vue';
import ServicesCategoriesAboutHeader from '@/components/global/header/ServicesCategoriesAboutHeader.vue';
import ServicesPackages from '@/pages/Services/ServicesPackages.vue';

import PartnersHeader from '@/components/global/header/PartnersHeader.vue';
import PartnersList from '@/pages/Partners/PartnersList.vue';
import PartnersNewPartner from '@/pages/Partners/PartnersNewPartner.vue';
import PartnersNewPartnerHeader from '@/components/global/header/PartnersNewPartnerHeader.vue';
import PartnersEditMain from '@/pages/Partners/PartnersEditMain.vue';
import PartnersEditPartner from '@/pages/Partners/PartnersEditPartner.vue';
import PartnersPartnerOrders from '@/pages/Partners/PartnersPartnerOrders.vue';
import PartnersEditPartnerHeader from '@/components/global/header/PartnersEditPartnerHeader.vue';
import PartnersHowItWorks from '@/pages/Partners/PartnersHowItWorks.vue';

import OrdersHeader from '@/components/global/header/OrdersHeader.vue';
import OrderDetailsHeader from '@/components/global/header/OrderDetailsHeader.vue';
import ContractorsHeader from '@/components/global/header/ContractorsHeader.vue';
import ContractorDetailsHeader from '@/components/global/header/ContractorDetailsHeader.vue';
import ContractorDetailsEditHeader from '@/components/global/header/ContractorDetailsEditHeader.vue';
import CustomersHeader from '@/components/global/header/CustomersHeader.vue';
import SupportCommunicationsHeader from '@/components/global/header/SupportCommunicationsHeader.vue';
import CustomerDetailsHeader from '@/components/global/header/CustomerDetailsHeader.vue';
import ObjectsHeader from '@/components/global/header/ObjectsHeader.vue';
import ObjectDetailsHeader from '@/components/global/header/ObjectDetailsHeader.vue';
import ObjectNewHeader from '@/components/global/header/ObjectNewHeader.vue';
import ObjectEditHeader from '@/components/global/header/ObjectEditHeader.vue';
import SettingsHeader from '@/components/global/header/SettingsHeader.vue';
import SettingsAdminHeader from '@/components/global/header/SettingsAdminHeader.vue';
import RequestsHeader from '@/components/global/header/RequestsHeader.vue';
import ServicesHeader from '@/components/global/header/ServicesHeader.vue';

import {
  AuthMiddleware,
  GuestMiddleware,
  PermissionMiddleware,
} from '@/router/middlewares';
import { ADMIN_PERMISSIONS } from '@/access/adminAccess';

Vue.use(VueRouter);

const Router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: {
        name: 'orders',
      },
    },
    {
      path: '/login',
      name: 'login',
      components: {
        default: Login,
      },
      beforeEnter: VueRouterMultiguard([GuestMiddleware]),
    },
    {
      path: '/orders',
      name: 'orders',
      redirect: {
        name: 'orders.active',
      },
      components: {
        default: Orders,
        header: OrdersHeader,
      },
      beforeEnter: VueRouterMultiguard([AuthMiddleware, PermissionMiddleware(ADMIN_PERMISSIONS.ORDERS)]),
      children: [
        {
          path: 'active',
          name: 'orders.active',
          components: {
            default: OrdersOrders,
          },
        },
        {
          path: 'completed',
          name: 'orders.completed',
          components: {
            default: OrdersOrders,
          },
        },
        {
          path: 'dispute',
          name: 'orders.dispute',
          components: {
            default: OrdersOrders,
          },
        },
        {
          path: 'promocodes',
          name: 'orders.promocodes',
          components: {
            default: OrdersOrders,
          },
          beforeEnter: VueRouterMultiguard([PermissionMiddleware(ADMIN_PERMISSIONS.SETTINGS)]),
        },
      ],
    },
    {
      path: '/orders/:id',
      name: 'orders.info',
      components: {
        default: OrderDetails,
        header: OrderDetailsHeader,
      },
      beforeEnter: VueRouterMultiguard([AuthMiddleware, PermissionMiddleware(ADMIN_PERMISSIONS.ORDERS)]),
    },
    {
      path: '/communications',
      name: 'communications',
      components: { default: SupportCommunications, header: SupportCommunicationsHeader },
      beforeEnter: VueRouterMultiguard([
        AuthMiddleware,
        PermissionMiddleware(ADMIN_PERMISSIONS.COMMUNICATIONS),
      ]),
    },
    {
      path: '/contractors',
      name: 'contractors',
      components: {
        default: Contractors,
        header: ContractorsHeader,
      },
      beforeEnter: VueRouterMultiguard([AuthMiddleware, PermissionMiddleware(ADMIN_PERMISSIONS.CONTRACTORS)]),
    },
    {
      path: '/partners',
      name: 'partners',
      components: {
        default: PartnersList,
        header: PartnersHeader,
      },
      beforeEnter: VueRouterMultiguard([AuthMiddleware, PermissionMiddleware(ADMIN_PERMISSIONS.PARTNERS)]),
    },
    {
      path: '/partners/new',
      name: 'partners.new',
      components: {
        default: PartnersNewPartner,
        header: PartnersNewPartnerHeader,
      },
      beforeEnter: VueRouterMultiguard([AuthMiddleware, PermissionMiddleware(ADMIN_PERMISSIONS.PARTNERS)]),
    },
    {
      path: '/partners/:id',
      name: 'partners.edit',
      components: {
        default: PartnersEditMain,
        header: PartnersEditPartnerHeader,
      },
      redirect: {
        name: 'partners.edit.main',
      },
      beforeEnter: VueRouterMultiguard([AuthMiddleware, PermissionMiddleware(ADMIN_PERMISSIONS.PARTNERS)]),
      children: [
        {
          path: '',
          name: 'partners.edit.main',
          components: {
            default: PartnersEditPartner,
          },
        },
        {
          path: 'orders',
          name: 'partners.edit.orders',
          components: {
            default: PartnersPartnerOrders,
          },
        },
        {
          path: 'howItWorks',
          name: 'partners.edit.howItWorks',
          components: {
            default: PartnersHowItWorks,
          },
        },
      ],
    },
    {
      path: '/partners/:id/orders',
      name: 'partners.orders',
      components: {
        default: PartnersEditPartner,
        header: PartnersEditPartnerHeader,
      },
      beforeEnter: VueRouterMultiguard([AuthMiddleware, PermissionMiddleware(ADMIN_PERMISSIONS.PARTNERS)]),
    },
    {
      path: '/contractors/:id',
      name: 'contractors.details',
      redirect: {
        name: 'contractors.details.info',
      },
      components: {
        default: ContractorDetails,
        header: ContractorDetailsHeader,
      },
      beforeEnter: VueRouterMultiguard([AuthMiddleware, PermissionMiddleware(ADMIN_PERMISSIONS.CONTRACTORS)]),
      children: [
        {
          path: '',
          name: 'contractors.details.info',
          components: {
            default: ContractorDetailsInfo,
          },
        },
        {
          path: 'orders',
          name: 'contractors.details.orders',
          components: {
            default: ContractorDetailsOrders,
          },
        },
        {
          path: 'transactions',
          name: 'contractors.details.transactions',
          components: {
            default: ContractorDetailsTransactions,
          },
        },
        {
          path: 'communications',
          name: 'contractors.details.communications',
          components: {
            default: ContractorDetailsCommunications,
          },
        },
      ],
    },
    {
      path: '/contractors/:id/edit',
      name: 'contractors.details.edit',
      components: {
        default: ContractorEdit,
        header: ContractorDetailsEditHeader,
      },
      beforeEnter: VueRouterMultiguard([AuthMiddleware, PermissionMiddleware(ADMIN_PERMISSIONS.CONTRACTORS)]),
    },
    {
      path: '/customers',
      name: 'customers',
      components: {
        default: Customers,
        header: CustomersHeader,
      },
      beforeEnter: VueRouterMultiguard([AuthMiddleware, PermissionMiddleware(ADMIN_PERMISSIONS.CUSTOMERS)]),
    },
    {
      path: '/customers/:id',
      name: 'customers.details',
      redirect: {
        name: 'customers.details.info',
      },
      components: {
        default: CustomerDetails,
        header: CustomerDetailsHeader,
      },
      beforeEnter: VueRouterMultiguard([AuthMiddleware, PermissionMiddleware(ADMIN_PERMISSIONS.CUSTOMERS)]),
      children: [
        {
          path: '',
          name: 'customers.details.info',
          components: {
            default: CustomerDetailsInfo,
          },
        },
        {
          path: 'orders',
          name: 'customers.details.orders',
          components: {
            default: CustomerDetailsOrders,
          },
        },
        {
          path: 'objects',
          name: 'customers.details.objects',
          components: {
            default: CustomerDetailsObjects,
          },
        },
        {
          path: 'communications',
          name: 'customers.details.communications',
          components: {
            default: CustomerDetailsCommunications,
          },
        },
      ],
    },
    {
      path: '/objects',
      components: {
        default: Objects,
      },
      beforeEnter: VueRouterMultiguard([AuthMiddleware, PermissionMiddleware(ADMIN_PERMISSIONS.SUBJECTS)]),
      children: [
        {
          path: '',
          name: 'objects',
          components: {
            default: ObjectsObjects,
            header: ObjectsHeader,
          },
        },
        {
          path: ':id',
          name: 'objects.details',
          redirect: {
            name: 'objects.details.info',
          },
          components: {
            default: ObjectDetails,
            header: ObjectDetailsHeader,
          },
          children: [
            {
              path: '',
              name: 'objects.details.info',
              components: {
                default: ObjectDetailsInfo,
              },
            },
            {
              path: 'actions',
              name: 'objects.details.actions',
              components: {
                default: ObjectDetailsActions,
              },
            },
            {
              path: 'orders',
              name: 'objects.details.orders',
              components: {
                default: ObjectDetailsOrders,
              },
            },
          ],
        },
        {
          path: ':id/edit',
          name: 'objects.edit',
          components: {
            default: ObjectEdit,
            header: ObjectEditHeader,
          },
        },
        {
          path: 'new',
          name: 'objects.new',
          redirect: {
            name: 'objects.new.single',
          },
          components: {
            default: ObjectNew,
            header: ObjectNewHeader,
          },
          children: [
            {
              path: 'single',
              name: 'objects.new.single',
              components: {
                default: ObjectNewSingle,
              },
            },
            {
              path: 'family',
              name: 'objects.new.family',
              components: {
                default: ObjectNewFamily,
              },
            },
          ],
        },
      ],
    },
    {
      path: '/settings',
      name: 'settings',
      redirect: {
        name: 'settings.limit',
      },
      components: {
        default: Settings,
        header: SettingsHeader,
      },
      beforeEnter: VueRouterMultiguard([AuthMiddleware, PermissionMiddleware(
        ADMIN_PERMISSIONS.SETTINGS,
        ADMIN_PERMISSIONS.ADMINS,
        ADMIN_PERMISSIONS.ANALYTICS,
        ADMIN_PERMISSIONS.MONITORING,
        ADMIN_PERMISSIONS.DATABASE,
      )]),
      children: [
        {
          path: 'limit',
          name: 'settings.limit',
          components: {
            default: SettingsLimit,
          },
          beforeEnter: VueRouterMultiguard([PermissionMiddleware(ADMIN_PERMISSIONS.SETTINGS)]),
        },
        {
          path: 'orders',
          name: 'settings.orders',
          components: {
            default: SettingsOrders,
          },
          beforeEnter: VueRouterMultiguard([PermissionMiddleware(ADMIN_PERMISSIONS.SETTINGS)]),
        },
        {
          path: 'legal',
          name: 'settings.legal',
          components: {
            default: SettingsLegal,
          },
          beforeEnter: VueRouterMultiguard([PermissionMiddleware(ADMIN_PERMISSIONS.SETTINGS)]),
        },
        {
          path: 'admins',
          name: 'settings.admins',
          components: {
            default: SettingsAdmins,
          },
          beforeEnter: VueRouterMultiguard([PermissionMiddleware(ADMIN_PERMISSIONS.ADMINS)]),
        },
        {
          path: 'admins/create',
          name: 'settings.admins.create',
          components: {
            default: () => import('@/pages/Settings/SettingsAdminCreate.vue'),
            header: SettingsAdminHeader,
          },
          beforeEnter: VueRouterMultiguard([PermissionMiddleware(ADMIN_PERMISSIONS.ADMINS)]),
        },
        {
          path: 'admins/:id',
          name: 'settings.admins.edit',
          components: {
            default: SettingsAdminEdit,
            header: SettingsAdminHeader,
          },
          beforeEnter: VueRouterMultiguard([PermissionMiddleware(ADMIN_PERMISSIONS.ADMINS)]),
        },
        {
          path: 'regions',
          name: 'settings.regions',
          components: {
            default: SettingsRegions,
          },
          beforeEnter: VueRouterMultiguard([PermissionMiddleware(ADMIN_PERMISSIONS.SETTINGS)]),
        },
        {
          path: 'sms',
          name: 'settings.sms',
          components: {
            default: SettingsSms,
          },
          beforeEnter: VueRouterMultiguard([PermissionMiddleware(ADMIN_PERMISSIONS.SETTINGS)]),
        },
        {
          path: 'templates',
          name: 'settings.templates',
          components: {
            default: SettingsMessageTemplates,
          },
          beforeEnter: VueRouterMultiguard([PermissionMiddleware(ADMIN_PERMISSIONS.SETTINGS)]),
        },
        {
          path: 'email',
          name: 'settings.email',
          components: {
            default: SettingsEmail,
          },
          beforeEnter: VueRouterMultiguard([PermissionMiddleware(ADMIN_PERMISSIONS.SETTINGS)]),
        },
        {
          path: 'analytics',
          name: 'settings.analytics',
          components: {
            default: SettingsAnalytics,
          },
          beforeEnter: VueRouterMultiguard([PermissionMiddleware(ADMIN_PERMISSIONS.ANALYTICS)]),
        },
        {
          path: 'monitoring',
          name: 'settings.monitoring',
          components: {
            default: SettingsMonitoring,
          },
          beforeEnter: VueRouterMultiguard([PermissionMiddleware(ADMIN_PERMISSIONS.MONITORING)]),
        },
        {
          path: 'db',
          name: 'settings.db',
          components: {
            default: SettingsDB,
          },
          beforeEnter: VueRouterMultiguard([PermissionMiddleware(ADMIN_PERMISSIONS.DATABASE)]),
        },
      ],
    },
    {
      path: '/requests',
      name: 'contractors.requests',
      redirect: {
        name: 'contractors.requests.registration',
      },
      components: {
        default: Requests,
        header: RequestsHeader,
      },
      beforeEnter: VueRouterMultiguard([AuthMiddleware, PermissionMiddleware(ADMIN_PERMISSIONS.CONTRACTORS)]),
      children: [
        {
          path: 'registration',
          name: 'contractors.requests.registration',
          components: {
            default: RequestsRegistration,
          },
        },
        {
          path: 'change',
          name: 'contractors.requests.change',
          components: {
            default: RequestsChange,
          },
        },
      ],
    },
    {
      path: '/services',
      name: 'services',
      redirect: {
        name: 'services.categories',
      },
      components: {
        default: Services,
        header: ServicesHeader,
      },
      beforeEnter: VueRouterMultiguard([AuthMiddleware, PermissionMiddleware(ADMIN_PERMISSIONS.SERVICES)]),
      children: [
        {
          path: 'categories',
          name: 'services.categories',
          components: {
            default: ServicesCategories,
          },
        },
        {
          path: 'packages',
          name: 'services.packages',
          components: {
            default: ServicesPackages,
          },
        },
      ],
    },
    {
      path: '/category',
      components: {
        default: Category,
        header: ServicesCategoriesAboutHeader,
      },
      beforeEnter: VueRouterMultiguard([AuthMiddleware, PermissionMiddleware(ADMIN_PERMISSIONS.SERVICES)]),
      children: [
        {
          path: '',
          name: 'services.categories.category',
          components: {
            default: Category,
          },
        },
        {
          path: ':id',
          name: 'services.categories.category.services',
          components: {
            default: CategoryServices,
          },
        },
        {
          path: ':id/about',
          name: 'services.categories.category.about',
          components: {
            default: CategoryAbout,
          },
        },
      ],
    },
    {
      path: '/services/categories/category/new',
      name: 'services.categories.category.new',
      components: {
        default: CategoryNew,
        header: ServicesCategoriesNewHeader,
      },
      beforeEnter: VueRouterMultiguard([AuthMiddleware, PermissionMiddleware(ADMIN_PERMISSIONS.SERVICES)]),
    },
    {
      path: '*',
      redirect: {
        name: 'home',
      },
    },
  ],
});

export default Router;
